// Check if OAuth is enabled via environment variable
const isOAuthEnabled = process.env.REACT_APP_OAUTH_ENABLED === 'true';

const awsConfig = {
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_USER_POOL_ID,
      userPoolClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID,
      identityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID,
      loginWith: {
        ...(isOAuthEnabled && {
          oauth: {
            domain: process.env.REACT_APP_OAUTH_DOMAIN,
            scopes: ['openid', 'email', 'profile', 'aws.cognito.signin.user.admin'],
            redirectSignIn: [process.env.REACT_APP_REDIRECT_SIGN_IN || 'http://localhost:3000/plans'],
            redirectSignOut: [process.env.REACT_APP_REDIRECT_SIGN_OUT || 'http://localhost:3000/'],
            responseType: 'code',
            providers: ['Google', 'Facebook', 'SignInWithApple'],
            additionalParameters: {
              prompt: 'login'
            }
          }
        }),
        email: true,
        username: false
      }
    }
  }
};

// Export OAuth enabled status for components to use
export const oauthEnabled = isOAuthEnabled;
export default awsConfig;